import { cn } from '@/lib/utils';
import { FC, ReactNode } from 'react';
import { InputContainer } from '../InputContainer';
import { InputProps, withField } from '../withField';

export interface TextAreaInputProps {
  placeholder?: string;

  suffix?: string | ReactNode;
  prefix?: string | ReactNode;
  onlyDigits?: boolean;
}

export const TextAreaInput: FC<InputProps<string> & TextAreaInputProps> = ({
  onChange,
  value,
  id,
  placeholder,
  suffix,
  prefix,
  onlyDigits,
  readonly,
  className,
  autofocus
}) => {
  return (
    <InputContainer className={cn('px-3 py-2', className)}>
      {prefix && <span className="text-secondary-std mr-0.5 text-sm">{prefix}</span>}
      <textarea
        autoFocus={autofocus}
        readOnly={readonly}
        value={value}
        rows={4}
        onChange={e => {
          let newValue = e.target.value;

          if (onlyDigits) {
            newValue = newValue.replace(/(?!^-)[^\d.]+/g, '');
          }

          onChange(newValue);
        }}
        id={id}
        className="placeholder:text-secondary-std block flex-1 border-0 bg-transparent p-0 text-sm placeholder:opacity-60 focus:ring-0 sm:leading-6"
        placeholder={placeholder}
      />
      {suffix && <span className="text-secondary-std ml-0.5 text-sm">{suffix}</span>}
    </InputContainer>
  );
};

export const TextAreaField = withField<string, TextAreaInputProps>(TextAreaInput);
